export const POSITION_Y_STICKYBAR_DISPLAY = -100

// `id` of the global StickyBarTop's RevStickyBar root. JP reuses it to query the
// bar element for tab-navigation visibility. StickyBarTop.vue binds its root id
// to this constant, so it is the single source of truth.
export const STICKY_BAR_TOP_ID = 'sticky-bar-top'
